import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Slide from '../RatingCurve/Slide';
import { confirmGetRated } from '../../actions';
import styles from './newGetRated.scss';
import { ratingTypes } from '../../utils/constants';

const UTRNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

class AdjustRatingContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUtr: props.user.claimedPlayer.myUtrSingles || 1,
        };
        this.submitValues = this.submitValues.bind(this);
    }

    async submitValues() {
        const values = {};
        values.playerId = this.props.user.claimedPlayer.playerId;
        values.selectedrating = this.state.selectedUtr;
        try {
            await this.props.confirmGetRated(values);
            this.props.ratingSubmitted();
        } catch (err) {
            // DO nothing
        }
    }

    render() {
        const { forceMobileUi, inPopUp } = this.props;
        const sliderStyle = {
            height: '510px',
        };
        if (this.sliderContainer) {
            const containerWidth = this.sliderContainer.getBoundingClientRect().width;
            if (containerWidth < 340) {
                sliderStyle.marginLeft = -(340 - containerWidth) / 2;
                sliderStyle.marginRight = -(340 - containerWidth) / 2;
            }
        }
        return (
            <div
                className={`${styles.selfRateComponent} ${forceMobileUi ? '' : styles.noForceMobileUi} ${styles.adjustRatingContent} ${inPopUp ? styles.inPopUp : ''}`}
                ref={(node) => {
                    if (!this.sliderContainer) {
                        this.sliderContainer = node;
                        this.forceUpdate();
                    }
                }}
            >
                <form>
                    <h4>
                        Adjust Your {ratingTypes.tennis}...
                    </h4>
                    <div style={sliderStyle}>
                        <Slide number={Math.round(this.state.selectedUtr)} noCurve={true} />
                    </div>
                    <ReactBootstrapSlider
                        max={16}
                        min={1}
                        step={1}
                        value={Math.round(this.state.selectedUtr)}
                        change={(ev) => {
                            this.setState({
                                selectedUtr: ev.target.value,
                            });
                        }}
                    />
                    <div className={`${styles.utrRangeNumbers}`}>
                        {UTRNumbers.map(number => (
                            <div
                                className={`${styles.utrRangeNumber}`}
                                key={`utr-number-${number}`}
                            >
                                {number}
                            </div>
                        ))}
                    </div>
                    <p className="mb16 mt16 text-dark text-center">
                        Move the slider to a rating that contains groups at your level.
                    </p>
                    <button
                        className={`btn btn-primary btn-xl btn-block text-uppercase mt24 mb24`}
                        type="button"
                        onClick={() => {
                            this.submitValues();
                        }}
                    >
                        Set Rating
                    </button>
                </form>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        confirmGetRated: (data) => dispatch(confirmGetRated(data)),
    };
}

export default connect(null, mapDispatchToProps)(AdjustRatingContent);
